/**
 * Height classes for each size variant.
 * Shared across TextField, Select, DatePicker, and DateRangePicker.
 */
export const sizeHeightClasses: Record<'sm' | 'md' | 'lg', string> = {
  sm: 'h-8', // 32px
  md: 'h-10', // 40px
  lg: 'h-12', // 48px
};

/**
 * Determine the text color for an input label based on state.
 */
export function getLabelColor(disabled: boolean, error: boolean): 'muted' | 'error' | 'default' {
  if (disabled) return 'muted';
  if (error) return 'error';
  return 'default';
}

/**
 * Build container classes for checkbox/radio wrapper.
 */
export function buildContainerClasses(disabled: boolean, className: string): string {
  return [
    'relative',
    'inline-flex',
    'items-start',
    'gap-2',
    disabled ? 'cursor-not-allowed' : 'cursor-pointer',
    className,
  ].filter(Boolean).join(' ');
}

/**
 * Base classes shared between checkbox and radio outer elements.
 */
export const controlBaseClasses = [
  'relative',
  'flex',
  'items-center',
  'justify-center',
  'shrink-0',
  'border-2',
  'transition-all',
  'duration-150',
  'ease-out',
];

/**
 * Compute the aria-describedby value from explicit and helper message IDs.
 */
export function computeAriaDescribedBy(
  ariaDescribedBy: string | undefined,
  messageId: string | undefined,
): string | undefined {
  return [ariaDescribedBy, messageId].filter(Boolean).join(" ") || undefined;
}
